import { CALL_API } from '../common/middleware/api';
import globalize from '../common/services/globalize';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const LANGUAGES_REQUEST = 'LANGUAGES_REQUEST';
export const LANGUAGES_SUCCESS = 'LANGUAGES_SUCCESS';
export const LANGUAGES_FAILURE = 'LANGUAGES_FAILURE';

export const loadLanguages = () => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [LANGUAGES_REQUEST, LANGUAGES_SUCCESS, LANGUAGES_FAILURE],
			endpoint: 'api/languages',
			onSuccess: (allLanguages) => {
				let selectedCulture = globalize.getSelectedCulture(getState().configuration.franchisor);
				if (!selectedCulture) {
					// select Owner's default language if user hasn't selected a language yet
					const defaultLanguage = allLanguages.find(language => language.isDefault);
					if (defaultLanguage) {
						selectedCulture = defaultLanguage.culture;
					}
				}

				if (selectedCulture) {
					dispatch(changeLanguage(selectedCulture));	// update the active language in the state after all languages are loaded
				}
			}
		}
	});
};

export const changeLanguage = (culture) => (dispatch, getState) => {
	const { configuration } = getState();
	globalize.setCurrentCulture(configuration.franchisor, culture);

	dispatch({
		type: CHANGE_LANGUAGE,
		culture
	});
};